import React, { useState, useEffect } from "react";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { Formik, Form, FormikHelpers } from "formik";
import { mixed, object } from "yup";

import {
  useGetLogoByIdQuery,
  useUpdateLogoMutation,
} from "src/services/LogoServices";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "src/utils/toaster/showToast";
import ATMPageLoader from "src/components/UI/atoms/ATMPageLoader/ATMPageLoader";
import EditLogo from "./LogoBanner";


export type LogoInitialValues = {
  image: any;
  fileType: string;
  // DSA certificate issuer, both optional.
  firmName: string;
  seal: any;
};

const EditLogoWrapper = () => {
  const { id = "" } = useParams();

  const navigate = useNavigate();
  const [updateLogo] = useUpdateLogoMutation();
  const { data, isLoading, isFetching } = useGetLogoByIdQuery(id);
  const initialData: LogoInitialValues = {
    image: "",
    fileType: "LOGO",
    firmName: "",
    seal: "",
  };
  // Form Initial Values
  const [intialValues, setInitialValues] = useState(initialData);
  useEffect(() => {
    if (!isFetching && !isLoading) {
      const dataBandataAppVideone = data?.data;
      let jobDataList: LogoInitialValues = {
        image: dataBandataAppVideone?.image,
        // A record saved without one would post the string "undefined" and
        // file the upload under uploads/undefined/.
        fileType: dataBandataAppVideone?.fileType || "LOGO",
        firmName: dataBandataAppVideone?.firmName || "",
        seal: dataBandataAppVideone?.sealImage || "",
      };
      setInitialValues(jobDataList);
    }
  }, [isLoading, isFetching, data]);

  // Form Validation Schema
  const validationSchema = object({
    image: mixed().required("Image is required"),
  });

  // Form Submit Handler
  const handleSubmit = (
    values: LogoInitialValues,
    { setSubmitting }: FormikHelpers<LogoInitialValues>
  ) => {
    const formData = new FormData();
    // fileType first: the upload middleware files the image by it.
    formData.append("fileType", values.fileType);
    formData.append("firmName", (values.firmName || "").trim());
    // Only a newly picked file is sent; otherwise the current one is kept.
    if (values.image instanceof File) formData.append("image", values.image);
    if (values.seal instanceof File) {
      formData.append("seal", values.seal);
    } else if (!values.seal && data?.data?.sealImage) {
      formData.append("removeSeal", "true");
    }
    
    updateLogo({
      id: id,
      body: formData,
    })
    .then((res: any) => {
      if (res.error) {
        showToast("error", res?.error?.data?.message);
        setSubmitting(false);
      } else {
        showToast("success", res?.data?.message);
        navigate("/logo-upload");
        setSubmitting(false);
      }
    });
  };
  if (isFetching || isLoading) {
    return <ATMPageLoader />;
  }
  return (
    <Formik
      enableReinitialize
      initialValues={intialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <SideNavLayout>
          <Form className="h-full">
            <EditLogo formikProps={formikProps} />
          </Form>
        </SideNavLayout>
      )}
    </Formik>
  );
};

export default EditLogoWrapper;
